var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.296,
    cy: 15.591,
    fill: "#335280",
    r: 6.796
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.296 2A6.796 6.796 0 00.5 8.796h13.591A6.796 6.796 0 007.296 2zM25.5 22.387H14.091l5.704-10.193z",
    fill: "#60B6B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.411 12.194C24.71 6.447 19.91 2 14.092 2v10.194z",
    fill: "#335280"
  })));
}
export default SvgCustom;